export enum DataSetTheme {
  Climate = "Climate",
  Environment = "Environment",
  Transportation = "Transportation",
  EnergyInfrastructure = "Energy Infrastructure",
  UrbanPlanning = "Urban Planning",
}
